import request from '@/config/request'

export default {

  searchRechargeOrder: function (orderCode) {
    return request({
      url: '/order/rechargeorder/searchrechargeorder',
      method: 'get',
      params: {
        ordercode: orderCode,
      }
    })
  },

  searchListRechargeOrder: function (customerCode, status) {
    return request({
      url: '/order/rechargeorder/searchlistrechargeorder',
      method: 'get',
      params: {
        customercode: customerCode,
        status: status
      }
    })
  },

  createRechargeOrder: function (customerCode, cardId,status) {
    return request({
      url: '/order/rechargeorder/createrechargeorder',
      method: 'get',
      params: {
        customercode: customerCode,
        cardid: cardId,
        status : status,
      }
    })
  },
  createWechatOrder: function (appKey, openId ,orderCode ) {
    return request({
      url: '/order/rechargeorder/createwechatorder',
      method: 'get',
      params: {
        appkey : appKey,
        openid : openId,
        ordercode: orderCode,
      }
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/order/rechargeorder.js